<template>
  <div :class="['listing-row', { inactive: listing.status === 'inactive' }]">
    <div class="listing-info">
      <div class="d-flex align-items-center gap-2">
        <span class="listing-title">{{ listing.title || listing.url || listing.id }}</span>
      </div>
      <div class="d-flex align-items-center gap-1 mt-1">
        <a v-if="listing.url" :href="safeHref(listing.url)" target="_blank" rel="noopener noreferrer" class="listing-url text-truncate">
          {{ listing.url.replace(/^https?:\/\//, '') }}
        </a>
        <StatusBadge v-if="listing.status === 'inactive'" variant="disabled" compact>
          Inactive
        </StatusBadge>
        <template v-else>
          <StatusBadge v-if="listing.evidence?.status === 'pending'" variant="primary" compact>
            <span class="pulse-dot" /> Capturing
          </StatusBadge>
          <StatusBadge v-else-if="listing.evidence?.status === 'captured'" variant="success" compact>
            <i class="bi bi-check"/> Screenshot captured
          </StatusBadge>
          <StatusBadge v-else-if="listing.evidence?.status === 'manual_upload'" variant="success" compact>
            <i class="bi bi-check"/> Screenshot uploaded
          </StatusBadge>
          <StatusBadge v-else-if="listing.evidence?.status === 'failed'" variant="danger" compact>
            <i class="bi bi-check"/> Screenshot failed
          </StatusBadge>
          <StatusBadge v-else variant="warning" compact>
            <i class="bi bi-slash-circle"/> No screenshot
          </StatusBadge>
        </template>
      </div>
    </div>

    <!-- Ellipsis menu -->
    <div v-if="showMenu" class="dropdown flex-shrink-0 ms-auto">
      <button
        type="button"
        class="btn btn-sm btn-link text-dark p-0"
        data-bs-toggle="dropdown"
      >
        <i class="bi bi-three-dots" />
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li v-if="canRecapture">
          <button type="button" class="dropdown-item d-flex align-items-center gap-2 small" @click="$emit('retry')">
            <i class="bi bi-camera" /> Recapture
          </button>
        </li>
        <li>
          <button type="button" class="dropdown-item d-flex align-items-center gap-2 small" @click="$emit('upload')">
            <i class="bi bi-upload" /> Upload screenshot
          </button>
        </li>
        <li v-if="['captured', 'manual_upload'].includes(listing.evidence?.status)">
          <EvidenceScreenshotButton
            :city-id="cityId"
            :listing-id="listing.id"
            :evidence="listing.evidence"
            class="dropdown-item d-flex align-items-center gap-2 small"
          />
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li>
          <button type="button" class="dropdown-item d-flex align-items-center gap-2 text-danger small" @click="$emit('mark-inactive')">
            <i class="bi bi-slash-circle" /> Mark inactive
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { safeHref } from '@/safeRendering';
import StatusBadge from '@/components/common/StatusBadge.vue';
import EvidenceScreenshotButton from './EvidenceScreenshotButton.vue';

export default {
  methods: {
    safeHref
  },
  components: { StatusBadge, EvidenceScreenshotButton },
  props: {
    cityId: String,
    listing: { type: Object, required: true },
    showMenu: { type: Boolean, default: false }
  },
  emits: ['retry', 'upload', 'mark-inactive'],
  computed: {
    canRecapture() {
      return this.listing.evidence?.status !== 'pending';
    }
  }
};
</script>

<style scoped>
.listing-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}
.listing-row.inactive {
  opacity: 0.55;
}
.listing-info {
  flex: 1;
  min-width: 0;
}
.listing-title {
  font-size: 0.8rem;
  font-weight: 600;
}
</style>
